// extracted by mini-css-extract-plugin
export default {"container":"proof-sent-to-customer_container__S98UD","greenButton":"proof-sent-to-customer_greenButton__AQ1OM"};